import { icons } from '../utils/icons';

export const projData = [
	{
	  id: 1,
	  name: 'Project Management System',
	  describtion:
		'Created an intuitive and efficient website for a company offering project management services. The website provides a comprehensive toolset for scheduling, tracking progress, and collaborating on projects. It’s designed to enhance team coordination, streamline workflow, and offer seamless user experience across devices.',
	  languages: [icons.html, icons.css, icons.mui, icons.bootstrap, icons.react, icons.express, icons.mongodb],
	  image: 'projectmanager.png',
	  link: 'https://project--manager.up.railway.app/signin',
	  gitLink: 'https://github.com/cheker-135/project-manger-front',
	  done: true,
	},
	{
	  id: 2,
	  name: 'Canning Food App',
	  describtion:
		'Developed a website for a canning food service company, showcasing their range of preserved food products, the canning process, and the company’s commitment to quality. The website offers easy navigation, information on available products, and contact details for customers interested in placing orders or learning more about food preservation services.',
	  languages: [icons.react, icons.mui, icons.css, icons.bootstrap, icons.redux, icons.express, icons.mongodb],
	  image: 'canningfood.png',
	  link: 'https://conserveriemenzah9.com/',
	  gitLink: 'https://github.com/cheker-135/canningFood-mern-app-client',
	  done: true,
	},
	{
	  id: 3,
	  name: 'Online Business Creation Platform',
	  describtion:
		'Created an engaging landing page for a platform that helps users start and manage online businesses. The website highlights the platform’s services, including website creation, marketing strategies, and business management tools, making it easy for users to get started and grow their businesses online.',
	  languages: [icons.react, icons.css, icons.bootstrap, icons.redux, icons.express, icons.mongodb],
	  image: 'launeaisiness.png',
	  link: ' https://online-business-creation-2xv2ye383.vercel.app ',
	  gitLink: 'https://github.com/cheker-135/LaunchEaisiness-App-client',
	  done: true,
	},
	{
		id: 4,
		name: 'MERN AI Chatbot',
		describtion:
		  'Developed a conversational AI chatbot using the MERN stack, Vite, and TypeScript. The chatbot leverages generative AI to provide intelligent responses, enhancing user engagement. Styled with Material-UI for a modern and responsive design, it delivers a seamless chatting experience.',
		languages: [icons.react, icons.typescript, icons.mui, icons.redux, icons.express, icons.mongodb],
		image: 'swiver.png',
		link: '',
		gitLink: 'https://github.com/cheker-135/MERN-ai-chatbot-client',
		done: true,
	  },
	  
	
	{
	  id: 4,
	  name: 'Portfolio Website',
	  describtion:
		'Designed and developed a personalized portfolio website for a full stack js developer , showcasing her past projects, design concepts, and professional achievements. The website serves as a virtual portfolio that effectively represents her expertise and experience in web development.',
	  languages: [icons.react, icons.css],
	  image: 'portfolio.png',
	  link: '',
	  gitLink: '',
	  done: true,
	},
	
	{
	  id: 5,
	  name: 'Awesome 3D Sidebar Component',
	  describtion:
		'Developed an innovative 3D sidebar component for a gym website, providing users with an interactive and visually appealing navigation experience. The sidebar showcases the gym’s services, pricing, and class schedules in a dynamic and user-friendly interface.',
	  languages: [icons.react, icons.css],
	  image: '3dcomponent.png',
	  link: 'https://3d-menu-react-component-j064503mf-hafoun9999-gmailcoms-projects.vercel.app/',
	  gitLink: 'https://github.com/cheker-135/animated-3d-component',
	  done: true,
	},
	{
	  id: 6,
	  name: 'React Magic Card Slider',
	  describtion:
		'Created a visually captivating e-commerce landing page using React.js and pure CSS. The site features a magical card slider to showcase products in an engaging manner, enhancing the user experience and driving product sales.',
	  languages: [icons.react, icons.css],
	  image: 'cardslider.png',
	  link: 'https://react-magic-card-slider-aknb2zqmp-hafoun9999-gmailcoms-projects.vercel.app ',
	  gitLink: 'https://github.com/cheker-135/react-card-slider',
	  done: true,
	},
	{
	  id: 7,
	  name: 'Wedding Planner App',
	  describtion:
		'Designed a landing page for a wedding planning service, featuring detailed information about the company’s offerings, pricing, and packages. The website aims to help couples plan their weddings with ease by providing a user-friendly interface for browsing services and contacting planners.',
	  languages: [icons.html, icons.css, icons.bootstrap],
	  image: 'weddingplanner.png',
	  link: 'https://wedding-planner-mern-app.vercel.app/home',
	  gitLink: 'https://github.com/cheker-135/wedding-planner_mern-app',
	  done: true,
	},
	
	{
	  id: 8,
	  name: 'PROGES Agency Landing Page',
	  describtion:
		'Created a landing page for an agency specializing in business solutions. The page highlights the agency’s services, portfolio, and client testimonials, providing visitors with clear information and a call to action for contacting the agency.',
	  languages: [icons.react, icons.css,icons.typescript,icons.vite, icons.tailwind],
	  image: 'proges.png',
	  link: 'https://proges.netlify.app/',
	  gitLink: 'https://github.com/cheker-135/web-development-agency-landing-page-',
	  done: true,
	},
  ];
  
